//libraries
import {React, Component} from 'react'
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";
import PxgLib from "pxg-js";
import Web3 from 'web3'

//Screens
import Landing from './screens/Landing/Landing';
import Search from './screens/Search/Search';
import NotFound from './screens/NotFound/NotFound';
import Glyph from './screens/Glyph/Glyph';
import Classify from './screens/Classify/Classify';
import MyGlyphs from './screens/MyGlyphs/MyGlyphs';
import Faqs from './screens/Faqs/Faqs';

//Components
import Footer from './components/Footer/Footer';

//Assets
import pxgGif from './assets/pxg.gif'
import './App.css';
import pxgABI from './assets/pxg-abi.json'


class App extends Component {
  constructor(props){
    super(props)
    this.state = {
       userUnclassifiedGlyphIds: []
    }

  }


 

  componentDidMount(){



  }


 


 
  render(){
    // console.log("unclassified glyphs:", this.state.userUnclassifiedGlyphIds)
    return (
      <div className="App">
                    
                            
          {/* <Link className="nav-link" to="/faqs" ><span className="nav-text">FAQs</span></Link> */}

          <Router>
            <Switch>
              <Route exact path ='/' component= {Landing}/>
              {/* <Route path ='/classify' render={() => <Classify userUnclassifiedGlyphIds={this.state.userUnclassifiedGlyphIds} />}/> */}
              <Route path ='/classify' component={Classify}/>
              <Route path='/search' component={Search}/>
              <Route path='/myglyphs' component={MyGlyphs}/>
              {/* <Route path='/faqs' component={Faqs}/> */}
              <Route path='/glyph/:id' component={Glyph}/>
              <Route path='/404' component={NotFound}/>
              <Redirect to='/404'/>
            </Switch>
          </Router>
          
          <Footer/>
      </div>
                              
    
    );
  
  }
}

export default App;
